import React from 'react';
import useLockingSystemStore from '../../stores/useLockingSystemStore';
import styles from './ToolCard.module.css';
import LockingSystemModal from './LockingSystemModal';
import LockingSystemDetailCard from './LockingSystemDetailCard';

const LockingSystemToolCard = () => {
  // Get locking system state from the dedicated store
  const lockingSystemState = useLockingSystemStore((state) => state.lockingSystem);
  const setLockingSystem = useLockingSystemStore((state) => state.setLockingSystem);

  const handleSelectLockingSystem = () => {
    setLockingSystem({ showModal: true });
  };

  const handleSystemSelect = (systemData) => {
    
    const { customizationEnabled: isCustomizable, ...system } = systemData;
    
    // Store the complete system object
    setLockingSystem({
      selectedSystem: system,
      customizationEnabled: isCustomizable,
      showModal: false
    });
  };

  const handleBackToModal = () => {
    setLockingSystem({
      selectedSystem: null,
      showModal: true
    });
  };

  const handleCloseModal = () => {
    setLockingSystem({ showModal: false });
  };


  // Check if a system is selected
  const hasSelectedSystem = lockingSystemState.selectedSystem !== null;

  // If a system is selected, show the detail card
  if (hasSelectedSystem) {
    return (
      <LockingSystemDetailCard
        selectedSystem={lockingSystemState.selectedSystem}
        onBackToModal={handleBackToModal}
        customizationEnabled={lockingSystemState.customizationEnabled}
      />
    );
  }

  return (
    <>
      <div className={styles.toolCard}>
        <div className={styles.toolCardHeader}>
          <h3>Locking System</h3>
        </div>
        
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 16,
          padding: '20px 0'
        }}>
          {/* Icon */}
          <div style={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 8
          }}>
            <img src="/tool_card_icons/locking_system.png" alt="Locking System" style={{ width: 30, height: 30 }} />
          </div>
          
          {/* Select Button */}
          <button
            onClick={handleSelectLockingSystem}
            style={{
              backgroundColor: '#7c3aed',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#6d28d9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#7c3aed'}
          >
            Select Locking system
          </button>
        </div>
      </div>

      {lockingSystemState.showModal && (
        <LockingSystemModal 
          onClose={handleCloseModal}
          onSelect={handleSystemSelect}
        />
      )}
    </>
  );
};

export default LockingSystemToolCard; 